import client from "../axios"
import {POST_STOCKBOOK_INVENTORY, GET_STOCKBOOK_INVENTORY,GET_STOCKPRODUCT_INVENTORY, GET_STOCKBOOK_SALE_DETAIL, GET_STOCKBOOK_REFUND_DETAIL, GET_STOCKBOOK_DAMAGEBOOK_DETAIL,
  POST_STOCKPRODUCT_INVENTORY, GET_STOCKPRODUCT_SALE_DETAIL, GET_STOCKPRODUCT_REFUND_DETAIL,
  POST_STOCKBOOK_EXCEL_UPLOAD, POST_STOCKPRODUCT_EXCEL_UPLOAD } from "./endpoint";


// 교재 입고 등록
export const postStockBookInventoryAPI = (data) => {
  return client.post(POST_STOCKBOOK_INVENTORY, data);
}

// 교재 재고 상세 - 판매
export const getStockBookSaleDetailAPI = (data) => {
  return client.get(GET_STOCKBOOK_SALE_DETAIL.replace(':product_cd', data.product_cd).replace(':order_date', data.order_date));
}
// 교재 재고 상세 - 환불
export const getStockBookRefundDetailAPI = (data) => {
  return client.get(GET_STOCKBOOK_REFUND_DETAIL.replace(':product_cd', data.product_cd).replace(':order_date', data.order_date));
}
// 교재 재고 상세 - 파본
export const getStockBookDamageBookDetailAPI = (data) => {
  return client.get(GET_STOCKBOOK_DAMAGEBOOK_DETAIL.replace(':product_cd', data.product_cd).replace(':order_date', data.order_date));
}
// 교재 일괄 등록 엑셀 업로드
export const postStockBookExcelUploadAPI = (data, registerDate) => {
  return client.post(POST_STOCKBOOK_EXCEL_UPLOAD.replace(':register_date', registerDate), data, { headers: { 'Content-Type': 'multipart/form-data' } });
}
// 물품 입고 등록
export const postStockProductInventoryAPI = (data) => {
  return client.post(POST_STOCKPRODUCT_INVENTORY, data);
}
// 물품 재고 상세 - 판매
export const getStockProductSaleDetailAPI = (data) => {
  return client.get(GET_STOCKPRODUCT_SALE_DETAIL.replace(':product_cd', data.product_cd).replace(':base_date', data.base_date));
}
// 교재 재고 상세 - 환불
export const getStockProductRefundDetailAPI = (data) => {
  return client.get(GET_STOCKPRODUCT_REFUND_DETAIL.replace(':product_cd', data.product_cd).replace(':base_date', data.base_date));
}
// 교재 재고 리스트(월별)
export const getStockBookInventoryAPI = (params) => {
  return client.get(GET_STOCKBOOK_INVENTORY, { params });
}
// 물품 재고 리스트(월별)
export const getStockProductInventoryAPI = (params) => {
  return client.get(GET_STOCKPRODUCT_INVENTORY, { params });
}
// 물품 일괄 등록 엑셀 업로드
export const postStockProducExcelUploadAPI = (data, registerDate) => {
  return client.post(POST_STOCKPRODUCT_EXCEL_UPLOAD.replace(':register_date', registerDate), data, { headers: { 'Content-Type': 'multipart/form-data' } });
}
